import {
  initialState,
  type CategoriesRecommendationsState,
} from '@/domains/productDiscovery/Recommendation/interfaces/msCatalogCategory';

import {
  FETCH_RECO_CATEGORIES,
  FETCH_RECO_CATEGORIES_FAILED,
  FETCH_RECO_CATEGORIES_SUCCESS,
  FETCH_RECO_TOP_SALES_CATEGORIES,
  FETCH_RECO_TOP_SALES_CATEGORIES_FAILED,
  FETCH_RECO_TOP_SALES_CATEGORIES_SUCCESS,
  type Action,
} from './CategoryRecommendation.actions';

export function recoCategoriesReducer(
  state: CategoriesRecommendationsState = initialState,
  action: Action,
): CategoriesRecommendationsState {
  switch (action.type) {
    case FETCH_RECO_CATEGORIES:
      return {
        fetching: true,
      };
    case FETCH_RECO_CATEGORIES_SUCCESS:
      return {
        fetching: false,
        recommendations: action.recommendations,
      };
    case FETCH_RECO_CATEGORIES_FAILED:
      return {
        fetching: false,
        error: action.error.message,
      };
    case FETCH_RECO_TOP_SALES_CATEGORIES:
      return {
        fetching: true,
      };
    case FETCH_RECO_TOP_SALES_CATEGORIES_SUCCESS:
      return {
        fetching: false,
        topSalesCategoriesRecommendations:
          action.topSalesCategoriesRecommendations,
      };
    case FETCH_RECO_TOP_SALES_CATEGORIES_FAILED:
      return {
        fetching: false,
        error: action.error.message,
      };
    default:
      return state;
  }
}
